export const characterRoles = ['tank', 'heal', 'melee', 'ranged'] as const

type CharacterRole = typeof characterRoles[number]
export default CharacterRole
